enum EntityStateActionTypeEnum {
  Request = 'REQUESTED',
  Query = 'QUERY',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED',
  Clear = 'CLEAR',
}

export default EntityStateActionTypeEnum;
